import { apiClient } from './api.client';

export interface UserProfile {
    user_id: string;
    email: string;
    name?: string;
    role: string;
    is_premium: boolean;
    subscription_status: string;
    premium_since?: string;
}

export const userService = {
    getProfile: async (): Promise<UserProfile | null> => {
        try {
            const response = await apiClient.get<UserProfile>('/api/user/profile');
            if (response.success && response.data) {
                return response.data;
            }
            return null;
        } catch (error) {
            console.error('Error fetching user profile:', error);
            return null;
        }
    },
};
